export const isPasswordMatch = (value, allValues) => {
  if (value) {
    if (value !== allValues.password) {
      return 'Password mismatch';
    }
  }
};
